module.exports = __webpack_public_path__ + "img/1506526050.4f5af967.jpg";